import { InitTelegramDataListener } from "./InitTelegramDataListener";

export const I18NLayer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  // TODO: i18n Provider context?
  <>
    {children}
    <InitTelegramDataListener />
  </>
);
